import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const THEMES = {
  MODERNE: 'moderne',
  JOUEURS: 'joueurs'
};

export const ThemeProvider = ({ children }) => {
  // lot CH — un seul thème : « Moderne ». La valeur `komerces_theme` du navigateur est
  // IGNORÉE : un poste qui avait choisi « Joueurs » revient à Moderne sans rien avoir à
  // effacer. Le code du thème horizontal reste en place, simplement inatteignable.
  const [currentTheme, setCurrentTheme] = useState(THEMES.MODERNE);

  useEffect(() => {
    localStorage.setItem('komerces_theme', currentTheme);
  }, [currentTheme]);

  const switchTheme = (newTheme) => {
    if (newTheme === THEMES.MODERNE) {
      setCurrentTheme(newTheme);
    }
  };

  const value = {
    currentTheme,
    switchTheme,
    isModerne: currentTheme === THEMES.MODERNE,
    isJoueurs: currentTheme === THEMES.JOUEURS,
    THEMES
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
